import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { zones } from "../../data/zones";
import { IconPin } from "../Icon";
import { Reveal } from "../motion/Reveal";
import { Stagger, StaggerItem } from "../motion/Stagger";

export function ZonesSection() {
  return (
    <section className="section bg-white">
      <div className="container-page grid lg:grid-cols-12 gap-10">
        <Reveal direction="left" className="lg:col-span-5">
          <span className="eyebrow">Zones d'intervention</span>
          <h2 className="mt-4">Vichy et 30 km autour</h2>
          <p className="mt-4 text-ink-muted text-lg">
            Nous couvrons Vichy et l'agglomération vichyssoise, ainsi que l'ensemble du bassin
            de l'Allier. Un doute sur votre commune&nbsp;?
          </p>
          <Link to="/contact" className="btn-secondary mt-6">
            Vérifier ma commune
          </Link>
        </Reveal>
        <Stagger
          as="ul"
          className="lg:col-span-7 grid sm:grid-cols-2 gap-3"
          staggerChildren={0.05}
        >
          {zones.map((z) => (
            <StaggerItem key={z.name} as="li">
              <motion.div
                whileHover={{ x: 4 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-surface-soft p-4 hover:border-brand-200 hover:bg-brand-50/50 transition-colors"
              >
                <span className="grid h-9 w-9 place-items-center rounded-lg bg-brand-700 text-white flex-none">
                  <IconPin className="h-4 w-4" />
                </span>
                <div>
                  <div className="font-semibold text-brand-900">
                    {z.name}{" "}
                    <span className="text-ink-muted font-normal">· {z.postalCode}</span>
                  </div>
                  <div className="text-xs text-ink-muted mt-0.5">
                    {z.distanceKm === 0 ? "Siège" : `${z.distanceKm} km de Vichy`}
                  </div>
                </div>
              </motion.div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
